const l = localStorage.getItem('defaultLanguage');

const state = { language: l };

const mutations = {
  changeLanguage(state, language){
    state.language = language;
    localStorage.setItem('defaultLanguage', language)
  }
}

const actions = {
  setLanguage({ state, commit }, language){
    commit('changeLanguage', language)
  }
}

export const language = {
  namespaced: true,
  state,
  actions,
  mutations
};